// List of supported CSS variable keys for composable UI styling
export type CssVariableKeyList =
  | 'color-primary'
  | 'color-primary-hover'
  | 'color-primary-active'
  | 'color-primary-contrast'
  | 'font-family'
  | 'font-size'
  | 'button-radius'
  | 'card-radius'
  | 'input-radius';

export const PREFIX = 'esw-composable-retailer-' as const;
export type PrefixedCssVar<K extends CssVariableKeyList = CssVariableKeyList> = `${typeof PREFIX}${K}`;
export type ComposableCssVariablesMap = Record<PrefixedCssVar, string>;
export const prefixed = <K extends CssVariableKeyList>(k: K): PrefixedCssVar<K> => `${PREFIX}${k}`;
